import { QueryClient } from '@tanstack/react-query';

export async function refreshSavedQuoteWorkflow(
  queryClient: QueryClient,
  eventId: unknown
) {
  const numericEventId = Number(eventId);
  if (!Number.isSafeInteger(numericEventId) || numericEventId <= 0) return;

  const eventIds: Array<string | number> = [
    String(numericEventId),
    numericEventId
  ];
  await Promise.all(
    eventIds.flatMap((id) =>
      ['qoute', 'jobs', 'eventBids'].map((key) =>
        queryClient.invalidateQueries({ queryKey: [key, id] })
      )
    )
  );
}
